import { isReactClass } from './isReactClass';

/**
 * @deprecated use same function from '@rchh/lowcode-utils' instead
 */
export function isReactComponent(obj) {
  return obj && (isReactClass(obj) || typeof obj === 'function');
}